import React from 'react';

import { Box, BoxProps } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { BsClock } from 'react-icons/all';

import { Select } from 'components/DataEntry';

export const publishedAtOptions = [
  { label: 'as of today', value: undefined },
  { label: 'over last day', value: 1 },
  { label: 'over last 7 days', value: 7 },
  { label: 'over last 15 days', value: 15 },
  { label: 'over last 30 days', value: 30 },
];

interface Props {
  historicalTime: Record<string, any>;

  setHistoricalTime(value: Record<string, any>);

  isDisabled?: boolean;
  width?: string | number;
  leftMessage?: string;
  isAFilter?: boolean;
  wrapperStyles?: BoxProps;
  showIsLAbel?: boolean;
}

export const SelectHistoricalOptions = (props: Props) => {
  const {
    historicalTime,
    setHistoricalTime,
    isDisabled = false,
    width = 56,
    leftMessage,
    wrapperStyles,
    isAFilter = false,
    showIsLAbel = true,
  } = props;
  return (
    <Box w={width} {...wrapperStyles}>
      <Select
        options={publishedAtOptions}
        value={historicalTime}
        onChange={setHistoricalTime}
        menuPortalTarget={document.body}
        menuPosition={'fixed'}
        isDisabled={isDisabled}
        valueContainerIcon={<BsClock />}
        leftMessage={leftMessage}
        isAFilter={isAFilter}
        showIconInValueContainer
        showUndefinedValueLabel
        showIsLabel={showIsLAbel}
      />
    </Box>
  );
};

export const getPublishedTime = days => {
  return !!days ? dayjs().subtract(days, 'days').utc().format() : undefined;
};
